import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import React from 'react';
import TextField from 'material-ui/TextField';
import Joi from 'joi';
import validation from 'react-validation-mixin';
import strategy from 'joi-validation-strategy';

class ClientEditDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      err_msg: '',
      client_data: {},
      open: false
    }

    this.validatorTypes = {
      name: Joi.string()
        .required()
        .min(2, 'utf8')
        .max(50, 'utf8')
    }

    this.open_edit = this.open_edit.bind(this)
    this.cancel_edit = this.cancel_edit.bind(this)
    this.getValidatorData = this.getValidatorData.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  getValidatorData() {
    return this.state.client_data
  }

  open_edit(data) {
    this.setState({
      client_data: data,
      err_msg: '',
      open: true
    })
  }

  cancel_edit() {
    this.setState({
      open: false
    })
  }

  handleChange(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState(Object.assign(
      this.state.client_data, {
        [name]: value
      }
    ));
  }

  handleBlur(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState(Object.assign(
        this.state.client_data, {
          [name]: value
        }
      ),
      this.props.handleValidation(name)
    )
  }

  handleSubmit(e) {
    this.props.validate((_err) => {
      if (_err) return
      this.props.submit_edit(
        this.state.client_data,
        (err) => {
          if (err) {
            this.setState({err_msg: err.message})
          }
          else this.setState({open: false}, () => {
            this.props.history.push('/clients/all')
          })
        }
      )
    })
  }

  renderHelperText(msg) {
    var err_msg = msg
    if (Array.isArray(msg) && msg.length > 0) {
      err_msg = msg[0]
    }
    return (
      <span styleName="">{err_msg}</span>
    )
  }

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        onClick={this.cancel_edit}
      />,
      <FlatButton
        label="Change"
        keyboardFocused={true}
        onClick={this.handleSubmit}
        disabled={!this.props.isValid()}
      />,
    ]
    var client_email = ''
    if (this.state.client_data.user) {
      client_email = this.state.client_data.user.username
    }
    return (
      <Dialog
        open={this.state.open}
        title="Edit Client Information"
        modal={true}
        actions={actions}
      >
        <div>{this.state.err_msg}</div>
        <TextField
          floatingLabelText="Client Email"
          floatingLabelFixed={true}
          name="email"
          value={client_email}
          disabled={true}
        />
        <br />
        <TextField
          floatingLabelText="Client Name"
          floatingLabelFixed={true}
          name="name"
          value={this.state.client_data.name || ''}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          errorText={this.renderHelperText(this.props.getValidationMessages('name'))} />
        <br />
      </Dialog>
    )
  }
}

ClientEditDialog.defaultProps = {
  submit_edit: null,
  history: null
}

export default validation(strategy)(ClientEditDialog)



// WEBPACK FOOTER //
// ./src/views/clients/client_edit.react.js